import { DocSearch } from '@docsearch/react'

import { docsearchConfig } from ':/_src/javascripts/sharedWithConsole/docsearch/config.ts'
import '{src}/javascripts/sharedWithConsole/docsearch/console.scss'
import { useWorkspaceSlug } from '~/api/swr/useWorkspaceSlug.ts'
import { useWorkspace } from '~/features/workspaces/data.ts'

import LeaveFeedbackLink from './LeaveFeedbackLink.tsx'
import MenuLink from './MenuLink.tsx'
import getLinks from '../utils/getLinks.ts'

function MenuUls() {
  const { data } = useWorkspace()
  const { slug } = useWorkspaceSlug()

  const isAdmin = data?.isAdmin ?? false
  const isFounder = data?.isFounder ?? false

  const userLinks = getLinks('user', slug)
  const adminLinks = getLinks('admin', slug)
  const founderLinks = getLinks('founder', slug)

  return (
    <>
      <ul className="main-menu__list main-menu__list--docsearch">
        <li className="main-menu__item main-menu__item--docsearch">
          <DocSearch {...docsearchConfig} />
        </li>
      </ul>

      <ul className="main-menu__list">
        {userLinks.map((link) => (
          <MenuLink key={link.type} link={link} />
        ))}
      </ul>

      {isAdmin && (
        <ul className="main-menu__list main-menu__list--admin">
          <li className="main-menu__item main-menu__item--header">Admin</li>
          {adminLinks.map((link) => (
            <MenuLink key={link.type} link={link} />
          ))}
        </ul>
      )}

      {isFounder && (
        <ul className="main-menu__list main-menu__list--admin">
          <li className="main-menu__item main-menu__item--header">Founder</li>
          {founderLinks.map((link) => (
            <MenuLink key={link.type} link={link} />
          ))}
        </ul>
      )}

      <LeaveFeedbackLink />
    </>
  )
}

export default MenuUls
